import { ArticleLabelTypes } from '../../article-labels/core/enums/ArticleLabelTypes';
import { IArticleLabel } from '../../article-labels/core/interfaces/IArticleLabel';
import { IEtikettOverview } from './interfaces/IEtikettOverview';
import { getEtikettenartByKey, STATUS_ETIKETTENART_NICHT_GEPFLEGT } from './etikettenarten.registry';

export function canPreviewEtikett(row: IEtikettOverview): boolean {
  return !!getEtikettenartByKey(row?.etikettenart)
    && !!row.articleVariantId
    && row.status !== STATUS_ETIKETTENART_NICHT_GEPFLEGT;
}

export function isPersistedArticleLabel(row: IEtikettOverview): boolean {
  return row.source === 'ArticleLabel' && !!row.id && row.rowKey.startsWith('ArticleLabel:');
}

export function canRegenerateEtikett(row: IEtikettOverview): boolean {
  return isPersistedArticleLabel(row) && !!getEtikettenartByKey(row.etikettenart);
}

export function toArticleLabel(row: IEtikettOverview): IArticleLabel {
  return {
    id: row.id,
    type: row.etikettenart as ArticleLabelTypes,
    articleId: row.articleId,
    articleVariantId: row.articleVariantId,
    articleName: row.articleName,
    articleVariantName: row.variantName,
    labelKey: row.labelKey,
  };
}
